import React, { useEffect, useState } from 'react';

const API_BASE = window.location.origin;
const formatDuration = seconds => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
const formatDate = value => value ? new Date(value).toLocaleString('en-IN', {
  day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
}) : '-';

export default function LeaderboardPage() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('adminToken');
  const headers = { Authorization: `Bearer ${token}` };
  const logout = () => {
    localStorage.removeItem('adminToken');
    window.location.assign('/admin/control');
  };

  useEffect(() => {
    if (!token) return logout();
    const load = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/admin/quiz-leaderboard`, { headers, cache: 'no-store' });
        if (response.status === 401) return logout();
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Unable to load the quiz leaderboard.');
        setTeams(data.teams || []);
      } catch (requestError) {
        setError(requestError.message || 'Unable to load the quiz leaderboard.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  async function exportLeaderboard() {
    try {
      const response = await fetch(`${API_BASE}/api/admin/quiz-leaderboard/export`, { headers });
      if (response.status === 401) return logout();
      if (!response.ok) throw new Error('Unable to export the quiz leaderboard.');
      const url = URL.createObjectURL(await response.blob());
      const link = document.createElement('a');
      link.href = url;
      link.download = 'napcon_online_quiz_leaderboard.xlsx';
      link.click();
      URL.revokeObjectURL(url);
    } catch (requestError) {
      setError(requestError.message || 'Unable to export the quiz leaderboard.');
    }
  }

  return (
    <main className="admin-container leaderboard-page">
      <header className="admin-header">
        <div>
          <h1>Online Quiz Leaderboard</h1>
          <p className="admin-subtitle">Private ranking: higher score first, then faster completion time. Equal score and time share a rank.</p>
        </div>
        <div className="admin-actions">
          <button className="export-btn" type="button" onClick={exportLeaderboard}>Export leaderboard</button>
          <a className="refresh-btn audit-link" href="/admin/control">Back to control</a>
          <button className="logout-btn" type="button" onClick={logout}>Logout</button>
        </div>
      </header>
      {error && <div className="error-message" role="alert">{error}</div>}
      <section className="leaderboard-table-wrap" aria-live="polite">
        {loading ? <div className="loading">Loading leaderboard...</div> : teams.length === 0 ? <div className="no-data">No Online Quiz submissions yet.</div> : (
          <div className="table-scroll">
            <table className="leaderboard-table">
              <thead><tr><th>Rank</th><th>Team</th><th>Participants</th><th>Institute</th><th>City</th><th>State</th><th>Score</th><th>Time</th><th>Submitted</th></tr></thead>
              <tbody>{teams.map(team => (
                <tr key={team.teamCode}>
                  <td className="leaderboard-rank">{team.rank}</td>
                  <td><strong>{team.teamCode}</strong></td>
                  <td>{team.participants || '-'}</td>
                  <td>{team.institute || '-'}</td>
                  <td>{team.city || '-'}</td>
                  <td>{team.state || '-'}</td>
                  <td className="leaderboard-score">{team.score}/{team.total}</td>
                  <td className="leaderboard-time">{formatDuration(team.timeTaken)}</td>
                  <td>{formatDate(team.submittedAt)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
}
